
// Components
const OrdersTable = () => import(/* webpackPrefetch: true, webpackChunkName: "orders-table"*/ '@/app/views/main-view/orders/containers/orders-table/orders-table.vue');

export default {
	name: 'OrdersContainer',
	components: { OrdersTable }
}